import changeWaLocal from '../functions/intel-wa-local'

export default ({ Vue }) => {
	Vue.prototype.$changeWaLocal = changeWaLocal
}
